var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eqInfo.airVentilator.totalFaults>0)?_c('li',[_c('router-link',{attrs:{"to":'/fault/' + _vm.id}},[_c('span',{staticClass:"img icon-type-6"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("报警")])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af3a8a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commen/eqAlarm/index.vue
// module id = null
// module chunks = 